import { useLocation, useNavigate } from 'react-router-dom';

import { guidesLocation } from './integrationGuidesRoute';
import {
  INTEGRATE_STEP_ENTRY_POINT,
  type NexusReferralCfOpening,
  nexusReferralState,
} from '../integrationWizard/nexusVocabulary';

export const useOpenNexusOnTheGuides = (): ((cfOpening: NexusReferralCfOpening) => void) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (cfOpening) =>
    navigate(guidesLocation(location.search), {
      state: nexusReferralState(INTEGRATE_STEP_ENTRY_POINT, { newConversation: true, cfOpening }),
    });
};
